export default "__VITE_ASSET__531adcb7__"